import InstaTaskMain from './InstaTaskMain';

export default InstaTaskMain;
